<template>
  <div>

    <div class="d-flex align-items-center filter-wrapper  flex-wrap">
      <div >

        <div class="form-group">
          <label>Дата анкетирования с</label>
            <date-component  v-model="currFilters.dateFrom"/>
        </div>
      </div>

      <div>
        <div class="form-group">
          <label>Дата анкетирования по</label>
          <date-component v-model="currFilters.dateTo"></date-component>
        </div>
      </div>

      <div >
        <div class="form-group">
          <label>Результат анкетирования</label>
          <select class="form-control" v-model="currFilters.resultType">
            <option v-bind:value='-1'>Все</option>
            <option v-for="el in resultTypeList" v-bind:key="el.id" :value="el.id">{{ el.text }}</option>
          </select>
        </div>
      </div>

      <div >
        <div class="form-group">
          <label>Статус</label>
          <select class="form-control" v-model="currFilters.status">
            <option v-bind:value='-1'>Все</option>
            <option v-for="el in statusList" v-bind:key="el.id" :value="el.id">{{ el.text }}</option>
          </select>
        </div>
      </div>

      <div >
        <div class="form-group">
          <label>Заполнены персон. данные</label>
          <select class="form-control" v-model="currFilters.fill">
            <option v-bind:value='-1'>Все</option>
            <option v-for="el in fillList" v-bind:key="el.id" :value="el.id">{{ el.text }}</option>
          </select>
        </div>
      </div>

      </div>
    <div class="form-group col-4">
      <div class="card-footer px-0  d-flex">
        <button-component @click="apply" class="btn-xs">Сформировать</button-component>
        <button-component kind="secondary" class="btn-xs" @click="reset">Сбросить</button-component>
        <button class="btn-success btn-d btn-xs" @click="download">
          <i class="fa fa-download"></i> Экспорт
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import {ru} from 'date-fns/locale'
import ButtonComponent from "@/common/ui/ButtonComponent";
import DateComponent from "@/common/components/DateComponent";
import Utils from "@/common/utils";

export default {
  name: "TmpPatientsFilters",
  components: {ButtonComponent, DateComponent},
  props: {
    filters: Object
  },
  data() {
    return {
      locale: ru,
      resultTypeList: [
        {
          text: "Высокий риск",
          id: 0
        },
        {
          text: "Средний риск",
          id: 1
        },
        {
          text: "Низкий риск",
          id: 2
        }
      ],
      statusList: [],
      fillList: [
        {
          text: "Да",
          id: 1
        },
        {
          text: "Нет",
          id: 0
        }
      ],
      currFilters: this.filters
    };
  },
  methods: {
    download(){
      this.$emit('download')
    },
    apply() {
      const filters = Object.assign({}, this.currFilters);
      this.$emit('apply', filters);
    },
    reset() {
      this.currFilters = {
        dateFrom: '',
        dateTo: '',
        resultType: -1,
        status: -1,
        fill: -1
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit('reset', filters);
    }
  },
  created() {
    Utils.loadSelectOptions("tmpPatientStatus", this.statusList);
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";
.btn-d{
  min-width: 120px;
  border: none;
  padding: 14px 24px;
  border-radius: 24px;
  i{
    padding-right: 12px;
  }
}
.form-group {
  label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }
}
.filter-wrapper{
  div:not(:last-child){
    margin-right: 16px;
  }
}
.card-footer {
  padding-top: 36px;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
}
</style>